/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ArtifactReasoningContent
 */
export interface ArtifactReasoningContent {
    /**
     * 
     * @type {string}
     * @memberof ArtifactReasoningContent
     */
    text: string;
}

/**
 * Check if a given object implements the ArtifactReasoningContent interface.
 */
export function instanceOfArtifactReasoningContent(value: object): value is ArtifactReasoningContent {
    if (!('text' in value) || value['text'] === undefined) return false;
    return true;
}

export function ArtifactReasoningContentFromJSON(json: any): ArtifactReasoningContent {
    return ArtifactReasoningContentFromJSONTyped(json, false);
}

export function ArtifactReasoningContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtifactReasoningContent {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'],
    };
}

export function ArtifactReasoningContentToJSON(json: any): ArtifactReasoningContent {
    return ArtifactReasoningContentToJSONTyped(json, false);
}

export function ArtifactReasoningContentToJSONTyped(value?: ArtifactReasoningContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
    };
}

